// Copyright (c) 2024 Deere & Company

import MeasurementReading from '@deere/cps-it.warranty-model-factory/lib/measurement-reading';
import t from 'tcomb';

const MeasurementReadingView = t.list(MeasurementReading, 'MeasurementReadingView');

export const getDefaultState = () => new MeasurementReadingView([]);

export default MeasurementReadingView;



// WEBPACK FOOTER //
// ./src/tcsm/wip/state/amount-of-use.js